export class WarningBody {   
    title : string;
    current_icon : string = "./assets/img/modal_v2/e-peligro.png";
    error_message : string;    
    main_button : string = null;
    text_align : string;
    list_content : string[];
    link_message: string;
    onMainAction : () => void;
    onLinkAction : () => void;
}


// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/modal/model/warning_body.ts